"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var ListItem = function ListItem(_ref) {
  var item = _ref.item,
      _onClick = _ref.onClick;
  return (0, _preact.h)("div", {
    className: "list-item",
    role: "button",
    tabIndex: 0,
    onClick: function onClick() {
      return _onClick(item);
    }
  }, (0, _preact.h)("div", null, item.title));
};

var List = function List(_ref2) {
  var items = _ref2.items,
      onClick = _ref2.onClick;
  return (0, _preact.h)("div", {
    className: "list"
  }, items.map(function (item) {
    return (0, _preact.h)(ListItem, {
      key: item.value,
      item: item,
      onClick: onClick
    });
  }));
};

var _default = List;
exports.default = _default;